<div class="loginContainer ">
<mat-card class="mat-elevation-z2" [ngClass]="{'loginCard ': !(isHandset$ | async) , 'loginCardHandset': (isHandset$ | async) }" >
 
  <form id="formContainer"  [formGroup]="loginForm" >
    <div  [ngClass]="{'headerImageWeb': !(isHandset$ | async) , 'headerImageHandset': (isHandset$ | async) }" class="headerFlex"  style="display: flex">
      <img src="assets/logo.png" alt="MDR logo" >
  </div>
  <div style="display: flex; color: #000000; opacity: 0.8; padding-top: 20px;" class="mat-display-4">
    Vanuatu Medical Disability Registry
   </div>
  <div style="display: flex;  opacity: 0.8; color: #000000;  padding-top: 28px;" class="mat-subheading-1">
    Login with phone number
   </div>
    <mat-form-field class="example-full-width" appearance="outline" style="width: 72%; padding-top: 40px;">
      <mat-label>Mobile Number</mat-label>
      <span matPrefix style="opacity: 0.38;">+678 &nbsp;</span>
      <input matInput  #mobileInput maxlength="10" minlength="5" [(ngModel)]="mobileNumber"  (keypress)="keyPressNumber($event)"  (focus)="this.loginForm.controls['mobileNumber'].markAsTouched();"
       formControlName="mobileNumber" name="mobileNumber"  required>
       <div  style="cursor:pointer" mat-icon-button matSuffix *ngIf="(loginForm.controls['mobileNumber'].invalid && loginForm.controls['mobileNumber'].touched)" >
        <mat-icon style="color: red;">   
          <span class="material-icons-outlined">
            error_outline
          </span>
        </mat-icon> 
      </div>
      <div  style="cursor:pointer" mat-icon-button matSuffix *ngIf="!(loginForm.controls['mobileNumber'].invalid && loginForm.controls['mobileNumber'].touched) && this.mobileNumber" (click)="clear()">
        <mat-icon  class="material-icons-outlined">
          cancel
        </mat-icon>
      </div>
      <mat-hint class="error-hint" 
      *ngIf="(loginForm.controls['mobileNumber'].hasError('minlength') && loginForm.controls['mobileNumber'].touched)" >Enter a valid mobile number
    </mat-hint>
    </mat-form-field>
    <div class="action-area" style="padding-top: 24px;">
      <button  (click)="onSubmit()" mat-raised-button [ngClass]="{'login-btn': !loginForm.invalid ,'login-btn-disabled':loginForm.invalid}" [disabled]="loginForm.invalid">
         <span [ngClass]="{'login-btn': !loginForm.invalid ,'login-btn-disabled':loginForm.invalid}">VERIFY</span>
      </button>
    </div>

</form>
</mat-card>

</div> 
